<template style="font-family: 'roboto';">
  <section>
    <div class="container">
      <v-row class="justify-content-center border-radius-lg mb-10 mt-12">
        <v-col cols="12">
          <v-row class="text-white ma-1" justify="space-around">
            <v-col cols="12" lg="12" class="mt-1">
              <label class="text-white new-section-title">Información completa del incentivo {{ (incentive.contents_info.title && incentive.contents_info.title.value != null) ? '"'+incentive.contents_info.title.value+'"' : '' }}</label>
            </v-col>
          </v-row>

          <hr class="horizontal mb-0 light line_gradient_background"/>

          <v-row class="text-white ma-1 mt-5" justify="space-around">
            <!-- <v-col v-if="incentive != null" cols="12" lg="12" class="mt-1 mb-5 py-0">
              <h3 class="text-white notranslate">Información del incentivo {{ (incentive.contents_info.title && incentive.contents_info.title.value != null) ? '"'+incentive.contents_info.title.value+'"' : '' }}</h3>
            </v-col> -->
            <v-col v-if="incentive != null" cols="12" class="mt-0 pt-0 secondary-text">
              <v-row class="text-white ma-0" justify="space-around">
                <v-col cols="12" lg="12" class="mt-1 py-0">
                  <span v-if="incentive.contents_info.body_incentive && incentive.contents_info.body_incentive.value != null" 
                    class="incentive_body_span" 
                    v-html="incentive.contents_info.body_incentive.value"
                  ></span>
                </v-col>

                <v-col cols="12" lg="12" class="mt-1 py-0">
                  <br>
                </v-col>

                <v-col cols="12" lg="3" class="mt-1 py-0 font-weight-bold">Teléfono:</v-col>
                <v-col cols="12" lg="9" class="mt-1 py-0">{{ (incentive.contents_info.phone && incentive.contents_info.phone.value != null) ? incentive.contents_info.phone.value : '---' }}</v-col>

                <v-col cols="12" lg="3" class="mt-1 py-0 font-weight-bold">Email:</v-col>
                <v-col cols="12" lg="9" class="mt-1 py-0">{{ (incentive.contents_info.email && incentive.contents_info.email.value != null) ? incentive.contents_info.email.value : '---' }}</v-col>
                
              </v-row>
            </v-col>
          </v-row>

          <hr class="horizontal mb-0 light line_gradient_background"/>

          <v-row class="text-white ma-1" justify="space-around">
            <v-col cols="12" lg="9" class="mt-1">
              <!--  -->
            </v-col>
            <v-col cols="12" lg="3" class="mt-1">
              <v-btn class="my-5 mx-2 main_gradient_background text-white text-transform-none"
                @click="goBackToPreviousPage"
              >
                Volver
              </v-btn>
              <v-btn
                class="my-5 mx-2 main_gradient_background text-white text-transform-none"
                @click="applyToIncentive"
                :loading="loadingBtn"
              >
                Postularme
              </v-btn>
            </v-col>
          </v-row>
          <!--
          <pre style="width: 600px; height: 300px; overflow-x: scroll; overflow-y: scroll;" class="text-white">
            incentive_id: {{ incentive_id }}
            incentive: {{ incentive }}
          </pre> 
          -->
        </v-col>
      </v-row>
    </div>
  </section>
</template>
    
<script>
  import Api from '@/api/Api';

  export default {
    name: "postulation-details",
    components: {
      //
    },
    data() {
      return {
        loggedUser: {
          Roles: [
            null
          ]
        },
        loadingBtn: false,

        application_id: null,
        application: null,


        incentive_id: null,
        incentive: null,
      };
    },
    computed: {
      //
    },
    watch: {
      // loggedUser(value) {
      //   if (value != null) {
      //     //
      //   }
      // },
    },
    methods: {
      getUserInfo: function () {
        Api.get('/auth/logged_user').then(response => {
          this.loggedUser = response.data;
        })
        .catch(error => this.errorHandling(error))
      },
      applyToIncentive: function () {
        this.loadingBtn = true;
        Api.get('/auth/user_is_logged').then(response => {
          if (response.data === 'not_logged') {
            this.$router.push({ 
              name: 'Apply for incentive without user', 
              params: { 
                incentive_id: this.incentive_id
              } 
            });
          } else {
            Api.get('/auth/logged_user').then(response => {
              this.user = response.data;
              if (this.user.Roles[0] == 'Producer') {
                this.$router.push({ 
                  name: 'Apply for incentive', 
                  params: { 
                    incentive_id: this.incentive_id
                  } 
                });
              } else {
                this.$swal('Acceso denegado', 'No se puede postular a un incentivo si no es una casa productora. Pruebe con otro usuario.', "error");
                this.$router.push({ 
                  name: 'Incentivos'
                });
              }
            })
            .catch(error => this.errorHandling(error))
          }
        })
        .catch(error => this.errorHandling(error))
        .finally(() => {
          this.loadingBtn = false;
        })
      },
      getIncentiveInformation: function () {
        Api.post(`section/get_specific_contents`, {
          section_id: this.incentive_id,
          contents: [
            'title',
            'body_incentive',
            'phone',
            'email'
          ],
          origin: 'incentive_full_info'
        })
        .then(response => {
          this.incentive = response.data;
          if (this.incentive != null && this.incentive.section_active == false) {
            this.$swal('Acceso Denegado', 'El incentivo que quiere consultar no está disponible', 'error');
            this.goBackToPreviousPage();
          }
        })
        .catch(error => this.errorHandling(error))
      },
      
      goBackToPreviousPage: function () {
        this.navigateTo('/incentives');
        /*
        this.$router.push({ 
          name: 'Applications management'
        })
        */
      }
    },
    beforeMount() {
      this.incentive_id = this.$route.params.incentive_id;
      this.getIncentiveInformation();
      
      // this.getUserInfo();
    },
    mounted() {
      //
    }
  };
</script>